import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, CardFooter } from '@components/layout/Card'

// Links through to the shared security page rather than duplicating the
// enrolment UI, which every profile type reaches at the same route.
export const SecurityCard = ({ securitySettingsPath }) => (
  <Card>
    <CardContent>
      <p>
        We text you a one time pin when you sign in. You can switch to a code from an authenticator
        app such as 1Password or Authy instead.
      </p>
    </CardContent>
    <CardFooter>
      <a href={securitySettingsPath}>Manage two factor authentication</a>
    </CardFooter>
  </Card>
)

SecurityCard.propTypes = {
  securitySettingsPath: PropTypes.string.isRequired,
}
